import { useIntl } from 'react-intl';

import { SearchInput } from '#src/atoms/inputs/SearchInput/index.tsx';
import { glossary } from '#src/lib/glossary.ts';

type Props = {
  handleChange: (event: {
    target: {
      value: string;
    };
  }) => void;
  value: string;
};

export const FilterSearchInput = ({ handleChange, value }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <SearchInput
      fullWidth
      rounded
      small
      withIcon
      onChange={handleChange}
      value={value}
      placeholder={formatMessage(glossary.search)}
    />
  );
};
